import React from 'react'
import { DateRangePicker } from 'rsuite';
import 'rsuite/DatePicker/styles/index.css';
import 'rsuite/dist/rsuite.min.css';


function DateRangePickerField({ value, onChange, ...props }) {

  const disabledDate = (date) => {
    const today = new Date();
    return date > today;
    };
    return (

        <div className='input-pad'>
                <DateRangePicker
                // showOneCalendar
                  format="MMM dd, yyyy"
                  placeholder="Select Date Range"
                  className='w-100'
                  value={value}
                  onChange={onChange}
                  appearance="subtle"
                  editable={false}
                  responsive={true}
                  disabledDate={disabledDate}
                  {...props}
                /> 
        </div>
    )
}

export default DateRangePickerField
